import { API_ENDPOINT } from "../services/client/HttpClient";

export function downloadFileFromUrl(apiName: string): void {
  const url = `${API_ENDPOINT}${apiName}`;
  const link = document.createElement("a");
  link.href = url;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  link.remove();
}
